import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Home from './pages/Home';
import Pokedex from './pages/Pokedex';
import Progreso from './pages/Progreso';
import Galeria from './pages/Galeria';
import { Lore, Personajes, Mapa } from './pages/OtherPages';
import Admin from './pages/Admin';
import './styles/global.css';

export default function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Routes>
        <Route path="/"           element={<Home />} />
        <Route path="/pokedex"    element={<Pokedex />} />
        <Route path="/lore"       element={<Lore />} />
        <Route path="/personajes" element={<Personajes />} />
        <Route path="/mapa"       element={<Mapa />} />
        <Route path="/galeria"    element={<Galeria />} />
        <Route path="/progreso"   element={<Progreso />} />
        <Route path="/admin"      element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}